import React from 'react';
import { EcardType } from '@graphql/generated';
import { Divider, ButtonV2, IconV2, TextV2 } from '@withjoy/joykit';
import { ReactComponent as TrackDelivery } from '@assets/icons/track-delivery.svg';
import { useHistory } from '@react-router';
import { useTranslation } from '@shared/core';
import { useEcardsTelemetry } from '@apps/ecard/Ecard.telemetry';

interface TrackGuestListProps
  extends Readonly<{
    eventHandle: string;
  }> {}

export const TrackGuestList: React.FC<TrackGuestListProps> = ({ eventHandle }) => {
  const { tq } = useTranslation('emailsAndEcards');
  const telemetry = useEcardsTelemetry();
  const history = useHistory();

  const handleOnClick = () => {
    telemetry.viewGuestListClick(EcardType.savethedate);
    history.push(`/${eventHandle}/edit/messaging`);
  };

  return (
    <>
      <Divider
        marginY="48px"
        width={['100%', '720px']}
      />
      <IconV2
        size="xl"
        marginBottom="16px"
      >
        <TrackDelivery />
      </IconV2>
      <TextV2 typographyVariant="hed3">{tq`Already sent? Track delivery in message Tracking`}</TextV2>
      <TextV2
        typographyVariant="body2"
        maxWidth="480px"
        textAlign="center"
        marginTop="8px"
        marginBottom="32px"
      >
        {tq`Track which guests have received and opened your Digital Card in the message tracker.`}
      </TextV2>
      <ButtonV2
        variant="outline"
        intent="neutral"
        shape="rounded"
        onClick={handleOnClick}
      >
        {tq`View Message Tracker`}
      </ButtonV2>
    </>
  );
};
